import { Link } from "react-router-dom";
import { categories } from "@/mocks/gossip";
import { siteInfo } from "@/mocks/site";

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-20 bg-secondary-950 text-background-100">
      <div className="mx-auto w-full px-4 py-14 md:px-6 lg:px-10">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <div className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500 text-lg font-bold text-background-50">
                瓜
              </span>
              <span className="font-heading text-xl font-bold text-background-50">{siteInfo.name}</span>
            </div>
            <p className="mt-5 max-w-sm text-sm leading-7 text-background-300">{siteInfo.description}</p>
            <div className="mt-6 flex flex-wrap gap-2.5">
              <span className="rounded-md bg-secondary-900 px-3 py-1.5 text-xs text-background-200">
                {siteInfo.workTime}
              </span>
            </div>
          </div>

          <div className="lg:col-span-2">
            <h3 className="font-heading text-sm font-semibold tracking-wide text-background-50">快速导航</h3>
            <ul className="mt-5 space-y-3 text-sm">
              <li>
                <Link to="/" className="text-background-300 transition-colors hover:text-primary-300">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/hot" className="text-background-300 transition-colors hover:text-primary-300">
                  热门大瓜
                </Link>
              </li>
              <li>
                <Link to="/submit" className="text-background-300 transition-colors hover:text-primary-300">
                  投稿入口
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-background-300 transition-colors hover:text-primary-300">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div className="lg:col-span-3">
            <h3 className="font-heading text-sm font-semibold tracking-wide text-background-50">瓜料分类</h3>
            <ul className="mt-5 grid grid-cols-2 gap-3 text-sm">
              {categories.map((category) => (
                <li key={category.id}>
                  <Link
                    to={`/hot?cat=${category.id}`}
                    className="text-background-300 transition-colors hover:text-primary-300"
                  >
                    {category.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <h3 className="font-heading text-sm font-semibold tracking-wide text-background-50">联系与投稿</h3>
            <ul className="mt-5 space-y-4 text-sm text-background-300">
              <li className="flex items-start gap-2.5">
                <i className="ri-mail-send-line mt-0.5 text-base text-primary-300" aria-hidden="true" />
                <span>
                  投稿邮箱
                  <br />
                  <span className="text-background-100">{siteInfo.email}</span>
                </span>
              </li>
              <li className="flex items-start gap-2.5">
                <i className="ri-shield-user-line mt-0.5 text-base text-primary-300" aria-hidden="true" />
                <span>全程匿名，投稿者身份不公开</span>
              </li>
              <li className="flex items-start gap-2.5">
                <i className="ri-time-line mt-0.5 text-base text-primary-300" aria-hidden="true" />
                <span>{siteInfo.founded}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-4 border-t border-secondary-800 pt-6 text-xs text-background-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} {siteInfo.name} · 内容为投稿者提供，站点仅作信息整理与核实</p>
          <p className="flex flex-wrap items-center gap-4">
            <Link to="/about" className="transition-colors hover:text-primary-300">
              内容原则
            </Link>
            <Link to="/submit" className="transition-colors hover:text-primary-300">
              投稿须知
            </Link>
            <span>不涉及未成年人隐私与私人住址</span>
          </p>
        </div>
      </div>
    </footer>
  );
}